// Get value from .NET form and then transmit it as part of the header for all AJAX requests.
// Used by the back end to validate that this is a legitimate request
export const antiForgeryAjax = () => {
  const token = $('#__AjaxAntiForgeryForm input[name=__RequestVerificationToken]').val();

  $.ajaxPrefilter((options, originalOptions, jqXHR) => {
    jqXHR.setRequestHeader('RequestVerificationToken', token);
  });
};



// WEBPACK FOOTER //
// ./src/ktu/js/helpers/xhr.js